// @flow
export const HOUR = 'hour';
export const DAY = 'day';

export const minutesInAnHour = 60;
export const minutesInADay = minutesInAnHour * 24;
export const minutesInAMonth = minutesInADay * 31;

export const pluralize = (value: number, unit: string): string =>
  value > 1 && !unit.endsWith('s') ? `${unit}s` : unit;

export const toMinutes = (value: number, unit: string): number => {
  switch (unit) {
    case HOUR:
      return value * minutesInAnHour;
    case DAY:
      return value * minutesInADay;
    default:
      return value;
  }
};

export const fromMinutes = (minutes: number, unit: string): number => {
  switch (unit) {
    case HOUR:
      return minutes / minutesInAnHour;
    case DAY:
      return minutes / minutesInADay;
    default:
      return minutes;
  }
};

export const displayStringFromMinutes = (
  minutes: number,
  unit: string
): string => {
  const timeValue = fromMinutes(minutes, unit);
  return `${timeValue} ${pluralize(timeValue, unit)}`;
};

export const bucketMinForDisplay = (min: number): string => {
  const timeBuckets = [minutesInAMonth, minutesInADay, minutesInAnHour];
  const timeUnits = ['month', 'day', 'hour'];
  const minInBucket = timeBuckets.map(t => min / t);
  const idx = minInBucket.findIndex(tt => tt >= 1);
  return `${minInBucket[idx]} ${timeUnits[idx]}${
    minInBucket[idx] > 1 ? 's' : ''
  }`;
};



// WEBPACK FOOTER //
// ./src/util/TimeUtils.js